import {HttpClient, HttpParams} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {catchError, map, Observable, of} from 'rxjs';
import {environment} from '../../environments/environment';

interface BootstrapResponse {
    settings?: {
        name?: string;
    };
}

@Injectable({providedIn: 'root'})
export class TenantInfoService {
    private readonly http = inject(HttpClient);

    getTenantName(tenantId: string): Observable<string | null> {
        const params = new HttpParams().set('tenantId', tenantId);
        return this.http
            .get<BootstrapResponse>(`${environment.apiBaseUrl}/bootstrap`, {params})
            .pipe(
                map((response) => response.settings?.name?.trim() || null),
                catchError((error) => {
                    console.error('Failed to load tenant information', error);
                    return of(null);
                }),
            );
    }
}
